import React, { useState } from "react";
import Icon, { IconTypeNames } from "Components/Icon";
import { endingIn } from "Utils/Utils";
import { useHistory, useLocation } from "react-router-dom";
import { Routes } from "Utils/Constants";
import useVipApiFetcher, {
  handleError,
  handleResponse,
  handleOkResponse,
} from "Utils/Hooks/useVipApiFetcher";
import useMode, { MODE } from "Utils/Hooks/useMode";
import useTransactionInitiated from "Utils/Hooks/useTransactionInitiated";
import useFundType, { FUNDTYPE } from "Utils/Hooks/useFundType";

import "./DeleteAccount.scss";
import { faro } from "@grafana/faro-react";
import Loading from "Components/Loading";

const DeleteAccount = () => {
  const fundType = useFundType();
  const history = useHistory();
  const location = useLocation();
  const vipApi = useVipApiFetcher();
  const mode = useMode();
  const { transactionInitiated } = useTransactionInitiated();

  const isDepositMode = mode === MODE.deposit;

  const { account, count } = { ...location.state };
  const [submitted, setSubmitted] = useState(false);

  const canDelete = count > 1;

  const onDeleteBank = async () => {
    setSubmitted(true);
    const body = {
      bankName: account.bankName,
      routingNumber: account.routingNumber,
      accountNumber: account.accountNumber,
      maskedAccountNumber: account.maskedAccountNumber,
    };

    vipApi
      .fetch("/api/bank", "DELETE", body)
      .then((response) => handleResponse(history, response))
      .then((response) =>
        handleOkResponse({
          history,
          response,
          title:
            fundType === FUNDTYPE.netspend
              ? "Netspend/Playcard Account Deleted"
              : "Bank Account Deleted",
          message: `Your ${response.body.bankName} account${endingIn(response.body.bankAccountNumber)} has been successfully deleted.`,
          customButtons: transactionInitiated
            ? [
                {
                  label: "Add New Funding Source",
                  route: Routes.ADD_ACCOUNT,
                },
                {
                  label: `Complete ${isDepositMode ? "Deposit" : "Withdraw"}`,
                  route: isDepositMode ? Routes.DEPOSIT : Routes.WITHDRAW,
                },
              ]
            : undefined,
          errorCustomButtons:
            mode === MODE.manageBanks && transactionInitiated
              ? [
                  {
                    label: "Try Again",
                    route: Routes.MY_ACCOUNTS,
                  },
                ]
              : transactionInitiated
                ? [
                    {
                      label: "Try Again",
                      route: Routes.MY_ACCOUNTS,
                    },
                    {
                      label: `Complete ${isDepositMode ? "Deposit" : "Withdraw"}`,
                      route: isDepositMode ? Routes.DEPOSIT : Routes.WITHDRAW,
                    },
                  ]
                : undefined,
        }),
      )
      .catch((error) => {
        faro.api.pushError(new Error("Delete Account Network Error"), {
          context: error,
        });
        handleError(error, history);
      });
  };

  const onCancel = () => {
    history.goBack();
  };

  const submitButton = submitted ? (
    <Loading />
  ) : (
    <button
      type="button"
      className="submit-button click-delete-account"
      onClick={onDeleteBank}
    >
      Yes
    </button>
  );

  return (
    <>
      <div className="response delete-account">
        {!canDelete && <Icon {...{ typeName: IconTypeNames.error }} />}
        <div className="response-header">Delete Account</div>
        <div className="response-message">
          Are you sure you want to delete your {account.bankName} account
          {endingIn(account.bankAccountNumber?.replaceAll("*", ""))}?
        </div>
        {submitButton}
        <button
          type="button"
          className="submit-button click-delete-account-cancel"
          onClick={onCancel}
        >
          Cancel
        </button>
      </div>
    </>
  );
};

export default DeleteAccount;
